class HorizontalScroller {
  constructor(wrapperSelector, listSelector = 'ul', scrollerLeftSelector = '.scroller-left', scrollerRightSelector = '.scroller-right') {
    // Selectors and constants
    this.wrapper = document.querySelector(wrapperSelector);
    this.list = this.wrapper.querySelector(listSelector);
    this.scrollerLeft = this.wrapper.querySelector(scrollerLeftSelector);
    this.scrollerRight = this.wrapper.querySelector(scrollerRightSelector);
    this.scrollBarWidths = 40;

    // Set initial margin
    this.list.style.marginLeft = '0px';

    // Bind events
    this.initialize();
    this.addEventListeners();
  }

  // Calculate total width of list items
  widthOfList() {
    return Array.from(this.list.querySelectorAll('a')).reduce((totalWidth, item) => {
      return totalWidth + item.offsetWidth;
    }, 0);
  }

  // Calculate the width of the hidden part of the list
  widthOfHidden() {
    const wrapperWidthNeg = 0 - this.wrapper.offsetWidth;
    const hiddenWidth = this.wrapper.offsetWidth - this.widthOfList() - this.getLeftMargin() - this.scrollBarWidths;
    const rightPos = document.documentElement.clientWidth - (this.list.lastElementChild.getBoundingClientRect().right + this.scrollBarWidths + 50);

    console.log(wrapperWidthNeg, hiddenWidth, rightPos);
    return Math.max(rightPos, Math.min(wrapperWidthNeg, hiddenWidth));
  }

  // Get the left margin of the list
  getLeftMargin() {
    const wrapperWidthNeg = 0 - this.wrapper.offsetWidth;
    const leftMargin = parseInt(this.list.style.marginLeft || 0);

    return Math.max(wrapperWidthNeg, leftMargin);
  }

  // Adjust visibility of scrollers and position of the list items
  reAdjust() {
    const rightPos = document.documentElement.clientWidth - (this.list.lastElementChild.getBoundingClientRect().right);

    // Show or hide the right scroller
    if (this.wrapper.offsetWidth < this.widthOfList() && rightPos < 0) {
      this.scrollerRight.style.display = 'flex';
    } else {
      this.scrollerRight.style.display = 'none';
    }

    // Show or hide the left scroller
    if (this.getLeftMargin() < 0) {
      this.scrollerLeft.style.display = 'flex';
    } else {
      this.list.style.marginLeft = `${-this.getLeftMargin()}px`;
      this.scrollerLeft.style.display = 'none';
    }
  }

  // Initialize adjustment on load
  initialize() {
    this.reAdjust();
  }

  // Add event listeners
  addEventListeners() {
    // Resize event listener on the parent wrapper
    new ResizeObserver(() => this.reAdjust()).observe(this.wrapper);

    // Right scroller click event
    this.scrollerRight.addEventListener('click', () => {
      this.scrollerLeft.style.display = 'flex';
      this.scrollerRight.style.display = 'none';

      this.list.style.transition = 'margin-left 0.6s';
      this.list.style.marginLeft = `${parseInt(this.list.style.marginLeft || 0) + this.widthOfHidden()}px`;

      this.list.addEventListener('transitionend', () => this.reAdjust(), {once: true});
    });

    // Left scroller click event
    this.scrollerLeft.addEventListener('click', () => {
      this.scrollerRight.style.display = 'flex';
      this.scrollerLeft.style.display = 'none';

      this.list.style.transition = 'margin-left 0.6s';
      this.list.style.marginLeft = `${parseInt(this.list.style.marginLeft || 0) - this.getLeftMargin()}px`;

      this.list.addEventListener('transitionend', () => this.reAdjust(), {once: true});
    });
  }
}

const loaderData = {
  "0": [
    {
      "id": null,
      "label": Utils.staticPH,
      "icon": this.staticPH,
      "campaignStart": true
    }
  ],
  "1": [
    {
      "id": null,
      "label": Utils.staticPH,
      "subLabel": Utils.staticPH,
      "icon": this.staticPH,
    }
  ],
  "da-672f35b6bd566": [
    {
      "id": null,
      "label": Utils.staticPH,
      "subLabel": Utils.staticPH,
      "durationText": Utils.staticPH,
      "icon": "\u003Ci class=\u0027fa fa-envelope\u0027\u003E\u003C\/i\u003E"
    }
  ],
  "p-da-672f35b6bd566": [
    {
      "id": null,
      "label": Utils.staticPH,
      "subLabel": Utils.staticPH,
      "icon": "\u003Ci class=\u0027fa fa-thumbs-down text-danger\u0027\u003E\u003C\/i\u003E"
    },
    {
      "id": null,
      "label": Utils.staticPH,
      "subLabel": Utils.staticPH,
      "icon": "\u003Ci class=\u0027fa fa-thumbs-up text-primary\u0027\u003E\u003C\/i\u003E"
    }
  ]
};

